import React, { ReactNode, useCallback } from 'react';
import styled from 'styled-components';
import { SdiCircleArrow, styles } from '@sdir/sds';

export interface DescriptionBoxInterface {
  text: string | ReactNode;
  header: string;
  topHeader?: string;
  className?: string;
  collapseable?: boolean;
  open?: boolean;
  callback?: () => void;
}

const DescriptionBox: React.FC<DescriptionBoxInterface> = ({
  text,
  header,
  topHeader,
  callback,
  open = false,
  className = '',
  collapseable = false,
}) => {
  const handleClick = useCallback(() => {
    callback?.();
  }, [callback]);
  return (
    <BodyFrame className={className}>
      <Header>
        <div>
          <h3>{topHeader}</h3>
          <h2>{header}</h2>
        </div>
        {collapseable && (
          <ArrowTrigger onClick={handleClick} data-testid="steponetoggle">
            <SdiCircleArrow
              size="m"
              color={styles.colors.primary}
              direction={open ? 'down' : 'up'}
            />
          </ArrowTrigger>
        )}
      </Header>
      <div className="description">{text}</div>
    </BodyFrame>
  );
};

export default DescriptionBox;

const ArrowTrigger = styled.div`
  cursor: pointer;
  color: ${styles.colors.primary} !important;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;

  h3 {
    font-size: 16px;
    line-height: 1em;
    margin: 0 0 8px 0;
    padding: 0;
    color: ${styles.colors.primary3};
    font-weight: normal;
    font-family: ${styles.fonts.stfMedium};
  }
`;

const BodyFrame = styled.article`
  padding: 4rem;
  width: 100%;
  height: auto;
  box-shadow: ${({ theme }) => theme.card.boxShadow};
  border-radius: ${({ theme }) => theme.card.borderRadius};
  background-color: ${({ theme }) => theme.colors.background.secondary};
  margin-bottom: 48px;

  h2 {
    margin: 0 0 2rem 0;
  }
  .description {
    font-size: 16px;
    line-height: 1.5;
    max-width: 720px;
  }
`;
